import { toggleScrolledHeader } from './_header';
import { fixCategoryTypes } from './_fix-category-types';

const $footer = document.querySelector('[data-role=footer]');
const $sections = document.querySelectorAll('[data-section]');


if ($footer) {
	const observer = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
			document.body.classList.toggle('scrolled-footer', entry.isIntersecting);
		});
	});

	observer.observe($footer);
}

if ($sections.length) {
	const observerSections = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
			entry.target.classList.toggle('visible', entry.isIntersecting);
		});
	}, {threshold: .25});

	$sections.forEach(section => observerSections.observe(section));
}

window.addEventListener('scroll', function() {
	toggleScrolledHeader();
	document.body.classList.toggle('scrolled', (window.scrollY > document.documentElement.clientHeight / 7));
	document.body.classList.toggle('scrolled-buy-now', (window.scrollY >= document.documentElement.clientHeight));
	fixCategoryTypes();
});

document.querySelector('[data-role=scroll-to-anchor]')?.addEventListener(
	'click',
	() => document.querySelector('[data-role=start-anchor]')?.scrollIntoView({behavior: 'smooth'})
);
